export * from '../tecnico/list/tecnicoList.component';
export * from '../tecnico/create/tecnicoCreate.component';
export * from '../tecnico/edit/tecnicoEdit.component';
export * from '../tecnico/detail/tecnicoDetail.component';
export * from '../tecnico/search/tecnicoSearch.component';